module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/oee_3@2x-573e336f14536f7697dd021f4b52174b.png";